<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_WKFL_BSC_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.workflowId }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.workflowName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRC_TASK_STNRD_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.processTaskStandardId }}
            </div>
          </div>      
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.moduleName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.workflowExplanationContent }}
            </div>
          </div>
          <div class="col-xs-1"/>
          <div class="col-xs-5"/>
        </div>
      </div>
      <div class="mrB30" />
      <div class="">
        <sui-diagram
          :model="diagramModel"
          :width="canvasWidth"
          :height="canvasHeight"
        />
      </div>
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCloseClick"
        >
          닫기
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';
// eslint-disable-next-line import/no-unresolved
import Diagram from '~common/components/form/SuiDiagram/components/SuiDiagram';

export default {
  name: 'PGE_CMR_00007', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {},
    },
    pageInitialData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      diagramModel: new Diagram.Model(),
      canvasWidth: 1150,
      canvasHeight: 400,
      frame0: {
        workflowId: '',
        processTaskStandardId: '',
        workflowName: '',
        moduleName: '',
        workflowExplanationContent: '',
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [],
  mounted() {
    if (this.pageInitialData.workflowId) {
      this.frame0.workflowId = this.pageInitialData.workflowId;
      this.frame0.processTaskStandardId = this.pageInitialData.processTaskStandardId;

      this.selectWorkflowInfo();
      this.selectDiagramData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    selectWorkflowInfo() {
      const queryParams = {
        workflowId: this.frame0.workflowId,
      };
      http.request(this.$options.name, 'DTS_CMR_00030', {
        query: queryParams,
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.frame0.workflowId = res.data[0].workflowId;
          this.frame0.workflowName = res.data[0].workflowName;
          this.frame0.workflowExplanationContent = res.data[0].workflowExplanationContent;
          this.frame0.moduleName = `${res.data[0].moduleName} / ${res.data[0].subModuleName}`;
        }
      });
    },
    selectDiagramData() {
      this.diagramModel = new Diagram.Model();
      http.request(this.$options.name, 'DTS_CMR_00021', {
        path: { 'workflow-id': this.frame0.workflowId },
        query: {
          processTaskStandardId: this.frame0.processTaskStandardId,
          canvasWidth: this.canvasWidth,
          canvasHeight: this.canvasHeight,
        },
      }).then(res => {
        console.log(res);
        const nodeMap = {};
        const { nodeList } = res.data;
        nodeList.forEach(node => {
          nodeMap[node.nodeId] = this.diagramModel.addNode(node.nodeName, node.posX, node.posY, node.width, node.height);
          nodeMap[node.nodeId].color = (node.processYn === 'Y') ? '#cc6666' : '#00cc66';
          if (node.processYn === 'Y') {
            nodeMap[node.nodeId].performUser = node.performUser;
            nodeMap[node.nodeId].performDate = node.performDate;
          }
        });
        nodeList.forEach(node => {
          node.nextNodeId.forEach(nextNodeId => {
            this.diagramModel.addLink(nodeMap[node.nodeId].addOutPort(''), nodeMap[nextNodeId].addInPort(''));
          });
        });
      });
    },
    onCloseClick() {
      this.closePagePopup();
    },

  },
};
</script>
<style scoped>
</style>
